class MobileMenu {
    constructor () {
        this.openButton = document.querySelector("#open-button")
        this.closeButton = document.querySelector("#close-button")
        this.canvas = document.querySelector(".mobile-menu-canvas")
        this.overlay = document.querySelector(".mobile-menu-overlay")
        this.menu = document.querySelector(".purse-world-mobile-menu")
        this.isOpen = false
        this.timer
        this.event()
    }
    //event
    event () {
        this.openButton.addEventListener("click", ()=>this.toggleMenu())
        this.closeButton.addEventListener("click", ()=>this.toggleMenu())
        this.overlay.addEventListener("click", ()=> { if(this.isOpen) this.toggleMenu()})
        this.menu.addEventListener("click", e => this.clickHandler(e))
    }
    clickHandler (e) {
        if (e.target.classList.contains("submenu-trigger") || e.target.classList.contains("chevron-icon")) this.toggleSubmenu(e)
    }

    //method
    
    //子菜单
    toggleSubmenu (e) {
        const thisLi = e.target.closest('li')
        const submenu = thisLi.children[1]
        let imgIcon = e.target
        while (imgIcon.tagName != "IMG") {
            imgIcon = imgIcon.children[0]
        }
        //清除上一个定时器，防止用户大量点击导致的动画不断执行
        if (this.timer) clearTimeout(this.timer)
        //打开和关闭子菜单
        if(submenu.classList.contains("hide")) {
            imgIcon.classList.add("rotate-[-90deg]")
            submenu.classList.remove("hide")
            thisLi.children[0].classList.add("shadow-lg")
            let finalHeight = `${submenu.scrollHeight}px`
            this.timer = setTimeout(()=>submenu.style.height = finalHeight, 20)
        }else{
            thisLi.children[0].classList.remove("shadow-lg")
            imgIcon.classList.remove("rotate-[-90deg]")
            submenu.style.height = "0px"
            submenu.classList.add("hide")
        }
    }
    //侧边栏菜单打开和关闭的方法
    toggleMenu () {
            this.canvas.classList.toggle("-translate-x-full")
            this.overlay.classList.toggle("hidden")
            document.body.classList.toggle("overflow-hidden")
            this.isOpen = !this.isOpen
        }
}
export default MobileMenu